export default __webpack_public_path__ + "static/media/4_3_hl.cdd7898a.png";